import { useState, useEffect } from "react";
import Button from "../../../../../components/Button";
import DialogComponent from "../../../../../components/DialogComponent";


type Props = {
    open: boolean;
    toggleDialog: (b: boolean) => void;
    setOpen: (b: boolean) => void;
    setComment: (str: string) => void;
    addCardHandle: () => void;
    value: string;
}

function SendCard(props: Props) {

    const { open, toggleDialog, setOpen, setComment, addCardHandle, value } = props;

    return (
        <DialogComponent open={open} toggleDialog={toggleDialog}>
            <div className="sendCard md:min-w-[600px]">
                <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">Отправка на согласование</span>
                <div id="comment_card_form" className='w-full mb-5 relative pt-6'>
                    <label htmlFor="comment_card" className="flex flex-column">
                        <span className="text-sm font-medium leading-6 text-gray-900">Комментарий</span>
                    </label>
                    <div className="mt-2">
                        <input
                            id="comment_card"
                            type="text"
                            autoComplete="off"
                            value={value}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Оставьте комментарий для коллег"
                            className="block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom placeholder:text-gray-400 bg-white"
                        />
                    </div>
                </div>
                <div className="divide-y mb-[40px] h-px border-t" />
                <div className="flex justify-between">
                    <div className="mr-5">
                        <Button
                            open={open}
                            setOpen={setOpen}
                            shadow={true}
                            classBg="btn-white"
                            text="Отмена"
                        />
                    </div>
                    <div className="ml-5">
                        <Button
                            open={open}
                            setOpen={setOpen}
                            classBg="btn-dark"
                            text="Отправить"
                            customFunction={addCardHandle}
                        />
                    </div>
                </div>
            </div>
        </DialogComponent>
    );
}

export default SendCard;



